export enum DomainMessageType {
  NOTE = "Note",
  CP_NOTE = "CPNote",
  DP_NOTE = "DPNote",
  SMS = "SMS",
  EMAIL = "Email",
  LETTERS = "Letters",
}
export enum DocumentType {
  DEBTOR = "Debtor",
  CREDITOR = "Creditor",
  OTHERPARTY = "OtherParty",
}
export enum DateFormat {
  REQ = "YYYY-MM-DD",
  CASE_DUE_DATE_FORMAT = "DD-MM-YYYY",
}
export enum EntityType {
  SUBCASE = "SubCase",
  CASE = "Case",
}
export enum FilterDocumentCriteria {
  ACTIVITY_NAME = "activityName",
  DOCUMENT_NAME = "documentName",
}
export enum SortDocumentCriteria {
  EXECUTED_TIME = "executedTime",
  UPLOADED_TIME = "uploadedDate",
}

export enum DocumentCriteria {
  PRINTED = "printed",
  UPLOADED = "uploaded",
}
export const INVALID_FORMATS = ['doc', 'docx', 'csv', 'xls', 'xlsx']